 
  <mat-expansion-panel>
    <mat-expansion-panel-header  collapsedHeight="75px">
     
        <mat-icon class="mr-3" [matBadge]="this.itemz?.results?.total" matBadgePosition="below after" matBadgeOverlap="true" matBadgeColor="primary">
          <fa-icon [icon]="metaIcon" class="fa-fw"></fa-icon>
        </mat-icon>
         <mat-panel-title>{{ 'TYPES.' + metaType | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div [vlist]="query" #itemz>

    </div>
    <mat-action-row class="text-right">

    
      <button mat-icon-button [matTooltip]="'PROJECTS.CLEAR' | translate" (click)="onDel.emit(this)" color="warn"><fa-icon icon="trash"></fa-icon></button> 
      <button mat-icon-button [matTooltip]="'PROJECTS.ADD_ALL' | translate" (click)="onAddFolder.emit(this)"><mat-icon>create_new_folder</mat-icon></button> 

      <button mat-icon-button [matTooltip]="'GENERIC.ADD' | translate" (click)="onAdd.emit(this)"><fa-icon icon="plus"></fa-icon></button> 
    </mat-action-row>
  </mat-expansion-panel>